import { render, staticRenderFns } from "./button-delete-account.vue?vue&type=template&id=0622ada5&"
import script from "./button-delete-account.vue?vue&type=script&lang=js&"
export * from "./button-delete-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports